import { createEvent, createEffect, createStore, sample } from 'effector';
import { DiContainer } from '@@/di/di-container';
import { AuthService } from '@@/auth/services/auth.service';

const authService = DiContainer.get(AuthService);

export const checkAuth = createEvent('checkAuth');
export const checkAuthFx = createEffect('checkAuthFx', {
  handler: () => authService.checkAuth(),
});
sample({
  source: checkAuth,
  target: checkAuthFx,
});

export const logout = createEvent('logout');

export const $isAuthorized = createStore(false, { name: 'isAuthorized' });
sample({
  source: checkAuthFx.doneData,
  target: $isAuthorized,
  fn: (data) => data.isValid,
});
sample({
  source: logout,
  target: $isAuthorized,
  fn: () => false,
});

export const $isAuthorizing = checkAuthFx.pending;
